import axios from "axios";

export function fetchArticleAppointment(clientCode, appointmentId, language) {
  let payload = {
    id: appointmentId,
    code: clientCode,
  };

  return axios.post("/appointment", payload, {
    params: {
      lang: language,
    },
  });
}

export function downloadArticleAppointment(appointmentId) {
  let payload = {
    appointmentId,
  };

  return axios.post("/appointment/download", payload);
}
